import MySettings from "../../components/MySettings/index";
import { connect } from "react-redux";
import { setReportWebSiteId } from "../../actions/Insights";
import {
  generateTag,
  clearInsightTagInfo,
  clearTagError,
  setTagWebsiteName,
  setTagWebsiteURL,
  getTagDetail,
  setTagCampaignName,
} from "../../actions/tags";
import { selectClient } from "../../actions/App";
import { setSettingsWebsiteId } from "../../actions/settings";

import { getClientSites, getClientTags } from "../../actions/Clients";
import { getClientInfo } from "../../actions/App";
import { push } from "react-router-redux";

const mapStateToProps = state => {
  const {
    websiteId,
    website_name,
    website_url,
    tag_info,
    tag_updated_success,
    tag_error_message,
    tag_variables,
    campaign_name,
  } = state.insights;
  const { selected_client, client_info, clients, roleId } = state.app;
  const { client_sites, client_tags } = state.clients;

  return {
    websiteId,
    selected_client,
    client_sites,
    client_info,
    clients,
    website_name,
    website_url,
    campaign_name,
    tag_info,
    tag_variables,
    tag_error_message,
    tag_updated_success,
    client_tags,
    roleId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClientSites: cid => {
      dispatch(getClientSites(cid));
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
      dispatch(setSettingsWebsiteId(id));
    },

    setTagWebsiteName: val => {
      dispatch(setTagWebsiteName(val));
    },

    setTagWebsiteURL: val => {
      dispatch(setTagWebsiteURL(val));
    },

    setTagCampaignName: val => {
      dispatch(setTagCampaignName(val));
    },

    generateTag: (clientId, val) => {
      dispatch(clearTagError());
      dispatch(generateTag(clientId, val));
    },

    saveTag: (clientId, uuid, val) => {
      //dispatch(saveTag(clientId, uuid, val))
      dispatch(getClientTags(clientId));
      dispatch(push(`/settings/tags/list`));
    },

    clearInsightTagInfo: () => {
      dispatch(clearInsightTagInfo());
    },

    clearInsightTagInfoAndRefreh: clientId => {
      dispatch(clearInsightTagInfo());
      dispatch(getClientTags(clientId));
      dispatch(push(`/settings/tags/list`));
    },

    getClientTags: clientId => {
      dispatch(getClientTags(clientId));
    },
    clearTagError: () => {
      dispatch(clearTagError());
    },
    createNewTag: () => {
      dispatch(clearTagError());
      dispatch(clearInsightTagInfo());
      dispatch(push(`/settings/tags/create`));
    },
    getTagDetail: (clientId, tagId, url) => {
      dispatch(getTagDetail(clientId, tagId, url));
    },
    getClientInfo: id => {
      dispatch(getClientInfo(id));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
  };
};

const MySettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MySettings);

export default MySettingsContainer;



// WEBPACK FOOTER //
// ./src/containers/Settings/MySettings.js